import page from './Home.vue';
export default page;


// WEBPACK FOOTER //
// ./src/components/page/home/index.js